<template>
	<component :is="tag" :style="style"><icon-button name="selection" @click="invertSelection"></icon-button></component>
</template>

<script setup lang="ts">
import IconButton from "../../helpers/IconButton.vue";
import {injectSelection, type RowSelection} from "./RowSelection";
import type {DataColumn} from "@t/fd/layout/Agenda.ts";
import {type CSSProperties, computed} from "vue";

const props = withDefaults(defineProps<{
	col: DataColumn,
	tag?: string
}>(), { tag: "th" });
const sel:RowSelection = injectSelection();

function invertSelection() {
	sel.invert();
}

const style = computed<CSSProperties>(() => {
	if (props.tag === "th") return { textAlign: "center" };
	return {}
});
</script>


<style>

</style>
